module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACySURBVHic7djRCcJAFETRTbABsZPUpxjR+tKJ2IGxhFkNGxI85/uBywUJTCkAAMD3upqj530Y083pMsWbPTrUHPVduVacjcuesk1VgZZ4PYa59W/86nie4j+oX+MheyZQIFAgUCBQ0PwrVvOl2LKqQO+53Fo/BAAA4I8Y7QOjfWC0DwxmgUCBQIFAgUCB0T4w2gMAAKzPaB8Y7QOjfWAwCwQKBAoECgQKjPaB0R4AAGjgA9rYJuYQ2r3cAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-list-active.png
// module id = wy9w
// module chunks = 265